import React, { useEffect } from 'react';
import { lazyForPaint, lazyAfterPaint } from 'react-loosely-lazy';
import type {
	EcosystemModuleProps,
	EcosystemTimeoutViewProps,
} from '@atlassian/jira-connect-utils';

import { useEntryPoint } from '@atlassian/jira-entry-point';
import { JiraEntryPointContainer } from '@atlassian/jira-entry-point-container';
import Placeholder from '@atlassian/jira-placeholder';
import { ecosystemExpiredViewEntryPoint } from './common/ui/expired-view/entrypoint';

const EcosystemModule = lazyForPaint(
	() => import(/* webpackChunkName: "async-connect-utils-ecosystem-module" */ './index'),
	{ ssr: true },
);

const EcosystemTimeoutView = lazyAfterPaint(
	() =>
		import(
			/* webpackChunkName: "async-connect-utils-ecosystem-timeout-view" */ './common/ui/ecosystem-timeout-view'
		),
	{ ssr: true },
);

export const EcosystemModuleAsync = (props: EcosystemModuleProps) => (
	<Placeholder name="ecosystem-module-async" fallback={<></>}>
		<EcosystemModule {...props} />
	</Placeholder>
);

export const EcosystemTimeoutViewAsync = (props: EcosystemTimeoutViewProps) => (
	<Placeholder name="ecosystem-timeout-view-async" fallback={<></>}>
		<EcosystemTimeoutView {...props} />
	</Placeholder>
);

const runtimeProps = {};
const entryPointParams = {};
export const EcosystemExpiredView = () => {
	const { entryPointActions, entryPointReferenceSubject } = useEntryPoint(
		ecosystemExpiredViewEntryPoint,
		entryPointParams,
	);

	useEffect(() => entryPointActions.load(), [entryPointActions]);

	return (
		<JiraEntryPointContainer
			entryPointReferenceSubject={entryPointReferenceSubject}
			id="EcosystemExpiredViewEntrypointContainer"
			packageName="@atlassian/jira-connect-utils-async"
			teamName="bento"
			runtimeProps={runtimeProps}
		/>
	);
};
